import { useCallback, useEffect, useState } from "react";
import { errorMessage, get } from "./api";

const clean = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v && v !== "all"));

export const fetchRuns = ({ from, to, status, locksmithId } = {}) =>
  get("/runs", clean({ from, to, status, locksmith_id: locksmithId }));
export const fetchRun = (id) => get(`/runs/${id}`);
export const fetchLocksmiths = () => get("/locksmiths");
export const fetchOfficers = () => get("/officers");

export function useAsync(fetcher, deps) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(fetcher, deps);
  const reload = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      setState({ data: await run(), loading: false, error: null });
    } catch (e) {
      setState({ data: null, loading: false, error: errorMessage(e) });
    }
  }, [run]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { ...state, reload, setData: (data) => setState((s) => ({ ...s, data })) };
}
